import { render, staticRenderFns } from "./input-color-group.vue?vue&type=template&id=dd4f93d8"
import script from "./input-color-group.vue?vue&type=script&lang=js"
export * from "./input-color-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports